// @flow
import * as React from 'react';
import { reducer, defaultState } from './answerEditingReducer';
import { saga } from './answerEditingSaga';
import { connect } from 'react-redux';
import { injectSaga, injectReducer } from 'store';
import {
  deleteAnswer,
  openAnswerEditor,
  editAnswer,
  resetView,
} from './answerEditingActions';

const REDUCER_NAME = 'answerEditing';
injectSaga(saga);
injectReducer({ [REDUCER_NAME]: reducer });

type ReduxStateProps = {
  state: typeof defaultState,
};
type ReduxDispatchProps = {
  onDelete: typeof deleteAnswer,
  onStartEdit: typeof openAnswerEditor,
  onCancelEdit: typeof resetView,
  onSubmitEdit: typeof editAnswer,
};
type OwnProps = {
  children: React.Node,
};
type Props = OwnProps & ReduxStateProps & ReduxDispatchProps;

const defaultContextValue: {
  state: typeof defaultState,
} = {
  state: defaultState,
};
// $FlowIssue
const Context = React.createContext(defaultContextValue);

export class StaticProvider extends React.Component<Props> {
  render() {
    return (
      <Context.Provider value={this.props}>
        {this.props.children}
      </Context.Provider>
    );
  }
}
const mapStateToProps = state => {
  return {
    state: state[REDUCER_NAME],
  };
};

export const AnswerEditingContext = {
  Provider: connect(mapStateToProps, {
    onDelete: deleteAnswer,
    onStartEdit: openAnswerEditor,
    onCancelEdit: resetView,
    onSubmitEdit: editAnswer,
  })(StaticProvider),
  StaticProvider,
  Consumer: Context.Consumer,
};



// WEBPACK FOOTER //
// ./src/containers/answer-editing/AnswerEditingContext.js